import { useState } from "react";
import { storyUrl } from "../../lib/navigation";
import { InlineIcon } from "./ui";
export function ReadingHeader({ storyId }: { storyId: string }) {
  const [shareStatus, setShareStatus] = useState("");

  async function copyStoryLink() {
    try {
      await navigator.clipboard.writeText(storyUrl(storyId));
      setShareStatus("הקישור הועתק!");
    } catch {
      setShareStatus("לא הצלחנו להעתיק את הקישור. נסו שוב.");
    }
  }

  return (
    <div className="story-actions">
      <details
        className="header-menu"
        onToggle={() => setShareStatus("")}
        onBlur={(event) => {
          if (!event.currentTarget.contains(event.relatedTarget as Node | null)) {
            event.currentTarget.open = false;
          }
        }}
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            event.currentTarget.open = false;
            event.currentTarget.querySelector("summary")?.focus();
          }
        }}
      >
        <summary className="header-menu__toggle" aria-label="שיתוף הטקסט">
          <InlineIcon name="share" /><span>שיתוף</span>
        </summary>
        <div className="header-menu__panel">
          <button className="header-menu__share" type="button" onClick={copyStoryLink}>
            <InlineIcon name="share" />
            <span>שיתוף הטקסט</span>
          </button>
          <p className="header-menu__status" role="status">{shareStatus}</p>
        </div>
      </details>
    </div>
  );
}

